export const LIST_DOC_REVISIONS_REQUEST = 'LIST_DOC_REVISIONS_REQUEST';
export const LIST_DOC_REVISIONS_SUCCESS = 'LIST_DOC_REVISIONS_SUCCESS';
